<template>
    <div>
        <!-- footer one starts -->
        <footer class="footer-up-area pad-50">
            <div class="centric-hold-80">
                <div class="row">
                    <div class="col-md-4">
                        <h2>{{providerTitle}} {{providerFirstName}} {{providerLastName}}</h2>
                    </div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-3 col-sm-6 col-xs-12" v-if="showLinks=='y'">
                                <p>About</p>
                                <ul>    
                                    <li><a href="http://doctorswati.com/about-me/">About Me</a></li>
                                    <li><a href="http://doctorswati.com/articles/">Articles</a></li>
                                    <li><a href="http://doctorswati.com/travel-medicine/">Travel Medicine</a></li>
                                    <li><a href="http://doctorswati.com/infectious-diseases/">Infectious Diseases</a></li>
                                    <li><a href="http://doctorswati.com/videos/">Videos</a></li>
                                    <li><a href="http://doctorswati.com/patient-reviews/">Patient Reviews</a></li>
                                    <li><a href="http://doctorswati.com/contact/">Contact</a></li>
                                </ul>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12" v-if="showLinks=='y'">
                                <p>For Patients</p>
                                <ul>
                                    <li><a href="#">Book Appointment</a></li>
                                    <li><a href="#">Online Consultation</a></li>
                                    <li><a href="#">Browse Specialists</a></li>
                                    <li><a href="#">Locate Us</a></li>
                                </ul>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12" v-if="showLinks=='y'">
                                <p>For Doctors</p>
                                <ul>
                                    <li><a href="#">Doctor Login</a></li>
                                    <li><a href="#">Research &amp; Education</a></li>
                                </ul>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12" v-if="showLinks=='y'">
                                <p>For Doctors</p>
                                <ul>
                                    <li><a href="#">Facebook</a></li>
                                    <li><a href="#">Twitter</a></li>
                                    <li><a href="#">Youtube</a></li>
                                    <li><a href="#">Google+</a></li>
                                    <li><a href="#">LinkedIn</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- centric-hold-80 -->
        </footer>
        <!-- footer one ends -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: "FooterTop",
  computed: {
    ...mapGetters([
        'tenantId',
        'protocol',
        'subDomain',
        'businessId',
        'businessName',    
        'businessType',
        'businessWebsiteUrl',
        'providerTitle',
        'providerFirstName',
        'providerLastName',
        'providerId',
        'providerColorCode',
        'providerPhone',
        'locationName',
        'locationId',
        'locationTz',
        'mapUrlEmbedded',
        'clientTz',
        'loading',
        'loadingMessage',
        'error',
        'errorMessage'
    ])},
    data () {
        return {
            "showLinks": "n",
            "currentURL": ""
        }
    },
    methods: {
        getURLDetails() {
            var currentUrl = window.location.hostname;
            console.log(currentUrl);
            this.currentURL = currentUrl;
            if( currentUrl.indexOf('arista') >= 0){
                this.showLinks = "y";
            }
        }
    },
    mounted(){
        this.getURLDetails();
        console.log(this.showLinks);
    },
};
</script>

<style>
</style>
